import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const ChangeOrderStatusSlice = createSlice({
    name: "changeOrderStatusRequest",
    initialState,
    reducers: {
        changeOrderStatusRequest(state) {
            state.loading = true;
        },
        changeOrderStatusRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        changeOrderStatusRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        changeOrderStatusStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    changeOrderStatusRequest,
    changeOrderStatusRequestSuccess,
    changeOrderStatusRequestError,
    changeOrderStatusStateReset,
} = ChangeOrderStatusSlice.actions;

export default ChangeOrderStatusSlice.reducer;
